import { Pathname } from "./pathname";

export const PathnameGenerator = (name: string) => {
  return Pathname.DASHBOARD_PROCUREMENT + name;
};

const REQUESTS = "requests";
const SETTINGS = "/settings";
const ORDERS = "orders";
const RFQ = "request-for-quote";
const RESPONSE_FOR_QUOTE = "response";
const PURCHASE_AGREEMENT = `purchase-agreements`;
const PURCHASE_ORDER = "purchase-order";
const VENDOR_RETURNS = "vendor-returns";
const DELIVERY_ORDER = "delivery-order";
const LANDED_COST = "landed-cost";
const FORMS = "forms";
const CUSTOM_FORM = "custom-form";
const PURCHASE_SETTINGS = "purchase-settings";
const TERMS_AND_CONDITIONS = "terms-and-conditions";
const VENDOR_MANAGEMENT = "master-data/vendor-management";
const REPORTS = "/reports";

// Report Paths
const PATHNAME_PROCUREMENT_REPORTS = {
  APPROVED_VS_PENDING_PO: `${REPORTS}/approved-vs-pending-po`,
  MATERIAL_REQUIREMENT_EXCEPTION: `${REPORTS}/material-requirement-exception`,
  SUPPLIER_CONTRACT_COMPLIANCE: `${REPORTS}/supplier-contract-compliance`,
  SUPPLIER_RANKING_SCORECARD: `${REPORTS}/supplier-ranking-scorecard`,
  PURCHASE_RETURN_REPORT: `${REPORTS}/purchase-return-report`,
  PURCHASE_ORDER_CANCELLATION: `${REPORTS}/purchase-order-cancellation`,
  PURCHASE_ORDER_DETAIL_REPORT: `${REPORTS}/purchase-order-detail`,
  PURCHASE_ORDER_SUMMARY_REPORT: `${REPORTS}/purchase-order-summary`,
  PURCHASE_TREND_REPORT: `${REPORTS}/purchase-trend`,
  RECEIVED_VS_ORDERED_REPORT: `${REPORTS}/received-vs-ordered`,
  SUPPLIER_AGING_PAYABLE_REPORT: `${REPORTS}/supplier-aging-payable`,
  PURCHASE_PRICE_VARIANCE_REPORT: `${REPORTS}/purchase-price-variance`,
  OPEN_PURCHASE_ORDER_REPORT: `${REPORTS}/open-purchase-order`,
  PURCHASE_INVOICE_SUMMARY_REPORT: `${REPORTS}/purchase-invoice-summary`,
  PURCHASE_INVOICE_DETAIL_REPORT: `${REPORTS}/purchase-invoice-detail`,
};

export const requestCrudPaths = {
  ADD_REQUEST: `/${REQUESTS}/add-${REQUESTS}`,
  EDIT_REQUEST: `/${REQUESTS}/:id/edit-${REQUESTS}`,
  VIEW_REQUEST: `/${REQUESTS}/:id/view-${REQUESTS}`,
};
export const requestPaths = {
  REQUESTS: `/${REQUESTS}`,
  ...requestCrudPaths,
};

//Purchase Agreement
export const purchaseAgreementPaths = {
  PURCHASE_AGREEMENT: `/${PURCHASE_AGREEMENT}`,
  ADD_PURCHASE_AGREEMENT: `/${PURCHASE_AGREEMENT}/add-${PURCHASE_AGREEMENT}`,
  EDIT_PURCHASE_AGREEMENT: `/${PURCHASE_AGREEMENT}/:id/edit-${PURCHASE_AGREEMENT}`,
  VIEW_PURCHASE_AGREEMENT: `/${PURCHASE_AGREEMENT}/:id/view-${PURCHASE_AGREEMENT}`,
};

// Settings Paths

export const settingPaths = {
  SETTINGS: `${SETTINGS}`,
  FORMS: `${SETTINGS}/${FORMS}`,
  CUSTOM_FORM: `${SETTINGS}/${CUSTOM_FORM}`,
  PURCHASE_SETTINGS: `${SETTINGS}/${PURCHASE_SETTINGS}`,
  TERMS_AND_CONDITIONS: `${SETTINGS}/${TERMS_AND_CONDITIONS}`,
  ADD_TERMS_AND_CONDITIONS: `${SETTINGS}/${TERMS_AND_CONDITIONS}/add-${TERMS_AND_CONDITIONS}`,
  EDIT_TERMS_AND_CONDITIONS: `${SETTINGS}/${TERMS_AND_CONDITIONS}/:id/edit-${TERMS_AND_CONDITIONS}`,
  VIEW_TERMS_AND_CONDITIONS: `${SETTINGS}/${TERMS_AND_CONDITIONS}/:id/view-${TERMS_AND_CONDITIONS}`,
};

// Orders Paths

export const responsefqCrudPaths = {
  ADD_RESPONSE_FOR_QUOTE: `/${ORDERS}/${RFQ}/add-${RESPONSE_FOR_QUOTE}`,
  EDIT_RESPONSE_FOR_QUOTE: `/${ORDERS}/${RFQ}/edit-${RESPONSE_FOR_QUOTE}`,
  VIEW_RESPONSE_FOR_QUOTE: `/${ORDERS}/${RFQ}/view-${RESPONSE_FOR_QUOTE}`,
  RESPONSE_FOR_QUOTE: `/${ORDERS}/${RFQ}/${RESPONSE_FOR_QUOTE}`,
};
export const rfqCrudPaths = {
  ADD_RFQ: `/${ORDERS}/${RFQ}/add-${RFQ}`,
  EDIT_RFQ: `/${ORDERS}/${RFQ}/:id/edit-${RFQ}`,
  VIEW_RFQ: `/${ORDERS}/${RFQ}/:id/view-${RFQ}`,
  VIEW_ANALYZE: `/${ORDERS}/${RFQ}/view-analyze`,
};
export const purchaseOrderCrudPaths = {
  ADD_PURCHASE_ORDER: `/${PURCHASE_ORDER}/add-${PURCHASE_ORDER}`,
  EDIT_PURCHASE_ORDER: `/${PURCHASE_ORDER}/:id/edit-${PURCHASE_ORDER}`,
  VIEW_PURCHASE_ORDER: `/${PURCHASE_ORDER}/:id/view-${PURCHASE_ORDER}`,
  GOODS_RECEIPT_NOTE: `/${PURCHASE_ORDER}/:poId/grn`,
  ADD_GOODS_RECEIPT_NOTE: `/${PURCHASE_ORDER}/:poId/grn/add-grn`,
  EDIT_GOODS_RECEIPT_NOTE: `/${PURCHASE_ORDER}/:poId/grn/:id/edit-grn`,
  VIEW_GOODS_RECEIPT_NOTE: `/${PURCHASE_ORDER}/:poId/grn/:id/view-grn`,
  BILLS: `/${PURCHASE_ORDER}/bills`,
};

export const vendorReturnsCrudPaths = {
  ADD_VENDOR_RETURNS: `/${VENDOR_RETURNS}/add-${VENDOR_RETURNS}`,
  EDIT_VENDOR_RETURNS: `/${VENDOR_RETURNS}/:id/edit-${VENDOR_RETURNS}`,
  VIEW_VENDOR_RETURNS: `/${VENDOR_RETURNS}/:id/view-${VENDOR_RETURNS}`,
  DELIVERIES: `/${VENDOR_RETURNS}/deliveries`,
};

export const rfqPaths = {
  RFQ: `/${ORDERS}/${RFQ}`,
  ...rfqCrudPaths,
  ...responsefqCrudPaths,
};
export const deliveryOrderCrudPaths = {
  ADD_DELIVERY_ORDER: `/${DELIVERY_ORDER}/add-${DELIVERY_ORDER}`,
  EDIT_DELIVERY_ORDER: `/${DELIVERY_ORDER}/:id/edit-${DELIVERY_ORDER}`,
  VIEW_DELIVERY_ORDER: `/${DELIVERY_ORDER}/:id/view-${DELIVERY_ORDER}`,
};
export const landedCostCrudPaths = {
  ADD_LANDED_COST: `/${LANDED_COST}/add-${LANDED_COST}`,
  EDIT_LANDED_COST: `/${LANDED_COST}/:id/edit-${LANDED_COST}`,
  VIEW_LANDED_COST: `/${LANDED_COST}/:id/view-${LANDED_COST}`,
};

export const purchaseOrderPaths = {
  PURCHASE_ORDER: `/${ORDERS}/${PURCHASE_ORDER}`,
  ...purchaseOrderCrudPaths,
};

export const vendorReturnsPaths = {
  VENDOR_RETURNS: `/${ORDERS}/${VENDOR_RETURNS}`,
  ...vendorReturnsCrudPaths,
};

export const deliveryOrderPaths = {
  DELIVERY_ORDER: `/${ORDERS}/${DELIVERY_ORDER}`,
  ...deliveryOrderCrudPaths,
};

export const landedCostPaths = {
  LANDED_COST: `/${ORDERS}/${LANDED_COST}`,
  ...landedCostCrudPaths,
};

const orderRoutes = {
  ...rfqPaths,
  ...purchaseOrderPaths,
  ...vendorReturnsPaths,
  ...deliveryOrderPaths,
  ...landedCostPaths,
};

export const vendorManagementPaths = {
  VENDOR_MANAGEMENT: `/${VENDOR_MANAGEMENT}`,
};

export const PathnamePurchase = {
  LANDING_PAGE: "/",
  LIST: "/list",
  ...requestPaths,
  ...settingPaths,
  ...orderRoutes,
  ...purchaseAgreementPaths,
  ...PATHNAME_PROCUREMENT_REPORTS,
  ...vendorManagementPaths,
};
